import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import sortasc from '../../../img/sort-asc.svg';
import sortdesc from '../../../img/sort-desc.svg';
import check from '../../../img/check.svg';
import emptybox from '../../../img/emptybox.svg';



export default class TrainingParticipantSelectScreen extends React.Component {

    constructor(props) {
        super(props);

        var trainingid = null
        var sortField = null
        var sortOrder = null
        var pageCount = 0
        var training = null
        
        const args = props.args === undefined ? {} : props.args

        if (args.training !== undefined) {
            training = args.training
        }

        if (args.trainingid !== undefined) {
            trainingid = args.trainingid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {args: args,
                      pageLimit: 25, 
                      pageCount: pageCount,   
                      nameCriteria: "",
                      prevNameCriteria:"",
                      trainingid: trainingid,
                      training: training,
                      sortField: sortField, 
                      sortOrder: sortOrder,
                      volunteers: [],
                      selected: []};

              

        this.nameSearch = this.nameSearch.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)
        this.setBuzyTime = this.setBuzyTime.bind(this)

        setTimeout(this.nameSearch, 2000);
    }

    async componentDidMount() {
        this.getDataWithCritera()
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }


    getDataWithCritera() {

        var parameters = {}

        if (this.state.trainingid) {
            parameters.trainingid = this.state.trainingid
        } 

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/training/participant/select', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({volunteers: res.data})
        })    
        .catch(error=>console.log(error))
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break 
            case "locationCaption" :
                if (currentField === "locationCaption") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "locationCaption"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    save() {
        BaseApi.post('/training/participant', this.state.selected, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
    }

    switchSelected(id) {
        var selected = this.state.selected

        if (this.isSelected(id)) {
            selected = selected.filter(item => item.volunteerid !== id)
        } else {
            selected.push({volunteerid: id, trainingid: this.state.trainingid, occupation: this.state.training.occupation})
        }

        this.setState({selected: selected})
    }

    isSelected(id) {
        return this.state.selected.filter(item => item.volunteerid === id).length > 0
    }
    
    setBuzyTime(event) {
        
        const id = event.target.id
        const value = event.target.value
        const idx = this.state.selected.findIndex(item => item.volunteerid == id)
        var selected = this.state.selected
        if (idx < 0) {
            selected.push({volunteerid: id, trainingid: this.state.trainingid, occupation: value})
        } else {
            selected[idx].occupation = value
        }
        this.setState({selected: selected})
    }

    getBuzyTime(id) {
        const item = this.state.selected.find(item => item.volunteerid == id)
        if (item === undefined) {
            return 0
        } else {
            return item.occupation
        }
    }

    renderVolunteer(volunteer) {
    
        return (
            <div class="row" style={{"height" : "50px"}}>
                    <div class="col-4 text-left border border-white" style={{"background-color" : "#eee"}}>{volunteer.name}</div>
                    <div class="col-3 text-left border border-white" style={{"background-color" : "#eee"}}>{volunteer.location}</div>
                    <div class="col-3 text-left border border-white" style={{"background-color" : "#eee"}}>{volunteer.phone}</div>
                    <div class="col-1 border border-white"  
                          style={{"background-color" : "#eee"}} 
                          onClick={()=>{this.switchSelected(volunteer.id)}}>
                          {this.isSelected(volunteer.id) && <img src={check} height="16" width="16"/>}
                          {!this.isSelected(volunteer.id) && <img src={emptybox} height="16" width="16"/>}
                    </div>
                    <div class="col-1 border border-white"  
                          style={{"background-color" : "#eee"}}>
                            <input  class="w-100"
                                   type="number" 
                                   name= "buzytime" 
                                   id={volunteer.id} 
                                   value={this.getBuzyTime(volunteer.id)}
                                   onChange={this.setBuzyTime}
                                   />
                    </div>
            </div>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Добавить участников к обучению"}/>
                <div class="mt-5 col-md-4">
                    <form title="Фильтр">
                        <div class="form-group">
                            <label for="name"> Имя:</label>
                            <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                        </div>
                    </form>
                </div>
                <div class="row" style={{"height" : "50px"}}>
                    <div class= "col-md-6 offset-md-6 float-left">
                        <button class="btn btn-primary" onClick={()=>{this.prevPage()}}>Предыдущие</button> 
                        <button class="btn btn-primary" style={{"margin-left" : "10px"}} onClick={()=>{this.nextPage()}}>Следующие</button> 
                        <button class="btn btn-primary" style={{"margin-left" : "10px"}} onClick={()=>{this.save()}}>Сохранить</button> 
                    </div>
                </div>
                <div class="row" style={{"height" : "50px"}}>
                    <div class="col-4 text-left border border-white"
                         id="nameCaption"    
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                            ФИО
                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-3 text-left border border-white"
                         id="locationCaption" 
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                         Локация
                         {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                         {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-3 text-left border border-white"
                         id="locationCaption" 
                         style={{"background-color" : "#0ee"}}
                         Телефон>
                    </div>
                    <div class="col-1 border border-white"
                         id="selectCaptuon" 
                         style={{"background-color" : "#0ee"}}>Выбор</div>    
                    <div class="col-1 border border-white"
                         id="buzyCaptuon" 
                         style={{"background-color" : "#0ee"}}>Часы</div>        
                </div>    
                {this.state.volunteers.map((value, index) => this.renderVolunteer(value))}
            
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/training/training-participant-select.js